export function addScript(url) {
  return new Promise((resolve, reject) => {
    var scriptElement = document.createElement('script');
    scriptElement.src = url;
    scriptElement.onload = (val) => {
      resolve(val);
    };
    scriptElement.onerror = (err) => {
      reject(err);
    };
    scriptElement.onabort = (err) => {
      reject(err);
    };
    document.head.appendChild(scriptElement);
  });
}
